import React from 'react';
import { motion } from 'framer-motion';
import FormComponent from '../../generic/FormComponent/FormComponent';
import TextInput from '../../generic/TextInput/TextInput';
import { Link } from 'gatsby';


import styles from './DataInnerForm.module.scss';

const DataInnerForm = ({
  state,
  control,
  errors,
  onClick,
}) => {
  return (
    <form className={styles.form} onSubmit={onClick}>
      <h2 className={styles.title}>Persoonlijke gegevens</h2>
      <div className={styles.formGroup}>
        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="firstname"
              friendlyName={'Voornaam'}
              rules={{
                required: true,
              }}
              defaultValue={state.data.firstname || ''}
              render={(props) => (
                <TextInput
                  wide
                  required
                  error={errors.firstname}
                  label={'Voornaam'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout>
            {errors.firstname && (
              <p>{errors.firstname.message}</p>
            )}
          </motion.div>
        </div>

        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="lastname"
              friendlyName={'Achternaam'}
              rules={{
                required: true,
              }}
              defaultValue={state.data.lastname || ''}
              render={(props) => (
                <TextInput
                  wide
                  required
                  error={errors.lastname}
                  label={'Achternaam'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.lastname && (
              <p>{errors.lastname.message}</p>
            )}
          </motion.div>
        </div>
      </div>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="email"
            friendlyName={'Email'}
            rules={{
              required: true,
              pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            }}
            defaultValue={state.data.email || ''}
            render={(props) => (
              <TextInput
                wide
                required
                error={errors.email}
                label={'Email'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout className={styles.error}>
          {errors.email && (
            <p>{errors.email.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="adress"
            friendlyName={'Adres'}
            rules={{
              required: true,
            }}
            defaultValue={state.data.adress || ''}
            render={(props) => (
              <TextInput
                wide
                required
                error={errors.adress}
                label={'Adres'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout className={styles.error}>
          {errors.adress && (
            <p>{errors.adress.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.formGroup}>
        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="houseNumber"
              friendlyName={'Huisnummer'}
              rules={{
                required: true,
              }}
              defaultValue={state.data.houseNumber || ''}
              render={(props) => (
                <TextInput
                  wide
                  required
                  error={errors.houseNumber}
                  label={'Huisnummer'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.houseNumber && (
              <p>{errors.houseNumber.message}</p>
            )}
          </motion.div>
        </div>
        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="postal"
              friendlyName={'Postcode'}
              rules={{
                required: true,
              }}
              defaultValue={state.data.postal || ''}
              render={(props) => (
                <TextInput
                  wide
                  required
                  error={errors.postal}
                  label={'Postcode'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.postal && (
              <p>{errors.postal.message}</p>
            )}
          </motion.div>
        </div>
      </div>

      <div className={styles.formGroup}>
        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="telephone"
              friendlyName={'Telefoonnummer'}
              rules={{
                required: true,
                pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
              }}
              defaultValue={state.data.telephone || ''}
              render={(props) => (
                <TextInput
                  wide
                  required
                  type="number"
                  error={errors.telephone}
                  label={'Telefoonnummer'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.telephone && (
              <p>{errors.telephone.message}</p>
            )}
          </motion.div>
        </div>

        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="telephonePartner"
              friendlyName={'Telefoonnummer partner'}
              rules={{
                pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
              }}
              defaultValue={state.data.telephonePartner || ''}
              render={(props) => (
                <TextInput
                  wide
                  type="number"
                  error={errors.telephonePartner}
                  label={'Telefoonnummer partner'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.telephonePartner && (
              <p>{errors.telephonePartner.message}</p>
            )}
          </motion.div>
        </div>
      </div>

      <p>
        Door uw gegevens hier boven in te vullen en door te gaan naar de volgende stap gaat u akkoord met de
        <Link to={'/privacy-verklaring'}><span className={styles.redirect}> privacy verklaring</span></Link>
        .
      </p>

      <div className={styles.controls}>
        <input className='button button--secondary' type="submit"  value="Akkoord en doorgaan"/>
      </div>
    </form>
  )
}

export default DataInnerForm;